import { useEffect, useState } from 'react'
import { Box } from '@mui/material'

const MapStaticComponent = ({
  fixedAddress,
  zoom = 16,
  width = 600,
  height = 180,
  borderRadius = 4,
  showStreetView = false,
  onCoordinatesFetched,
}) => {
  const [dataUrl, setDataUrl] = useState(null)
  const [coordinates, setCoordinates] = useState(null)
  const [streetViewAvailable, setStreetViewAvailable] = useState(true)

  useEffect(() => {
    const fetchMapImageAsDataUrl = async () => {
      if (!fixedAddress || fixedAddress.includes(', -,') || fixedAddress.split(',').length < 3) return

      try {
        const geocodeRes = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(fixedAddress)}&key=${
            process.env.REACT_APP_GOOGLE_MAPS_API_KEY
          }`,
        )
        const geocodeData = await geocodeRes.json()
        const location = geocodeData.results?.[0]?.geometry?.location
        if (!location) return

        const { lat, lng } = location
        setCoordinates({ lat, lng })
        if (onCoordinatesFetched) {
          onCoordinatesFetched({ lat, lng })
        }

        let imageUrl
        
        if (showStreetView) {
          const metadataRes = await fetch(
            `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
          )
          const metadataData = await metadataRes.json()
          
          if (metadataData.status === 'OK') {
            imageUrl = `https://maps.googleapis.com/maps/api/streetview?location=${lat},${lng}&size=${width}x${height}&fov=80&heading=0&pitch=0&source=outdoor&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
            setStreetViewAvailable(true)
          } else {
            imageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${width}x${height}&markers=color:red%7C${lat},${lng}&maptype=roadmap&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
            setStreetViewAvailable(false)
          }
        } else {
          imageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${width}x${height}&markers=color:red%7Clabel:A%7C${lat},${lng}&maptype=roadmap&format=png&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
        }

        const imageRes = await fetch(imageUrl)
        const blob = await imageRes.blob()
        const reader = new FileReader()
        reader.onloadend = () => {
          setDataUrl(reader.result)
        }
        reader.readAsDataURL(blob)     
      } catch (error) {
        console.error('Error fetching static map or street view image', error)

        if (coordinates) {
          const fallbackUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coordinates.lat},${coordinates.lng}&zoom=${zoom}&size=${width}x${height}&markers=color:red%7C${coordinates.lat},${coordinates.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
          try {
            const fallbackRes = await fetch(fallbackUrl)
            const blob = await fallbackRes.blob()
            const reader = new FileReader()
            reader.onloadend = () => setDataUrl(reader.result)
            reader.readAsDataURL(blob)
          } catch (fallbackError) {
            console.error('Fallback also failed', fallbackError)
          }
        }
      }
    }

    fetchMapImageAsDataUrl()
  }, [fixedAddress, zoom, width, height, showStreetView])

  if (!dataUrl) return null

  return (
    <Box sx={{ borderRadius, overflow: 'hidden', position: 'relative' }}>
      <img
        src={dataUrl}
        alt={showStreetView && streetViewAvailable ? 'Street View' : 'Static Map'}
        style={{ width: '100%', height: 'auto', borderRadius }}
      />
    </Box>
  )
}

export default MapStaticComponent